import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useCourseSearch } from "hooks/useCourseSearch";
import { useCourseById } from "utils/courseService";

const CourseAutocomplete = ({ universityId, courseId, onSelect, label = "Course *" }) => {
  const { data: hydratedCourse } = useCourseById(courseId);

  const { inputValue, setInputValue, debouncedSearch, options, loading, listboxProps } =
    useCourseSearch({ selectedCourse: hydratedCourse, universityId });

  const selectedCourse = hydratedCourse ?? options.find((c) => c.courseId === courseId) ?? null;

  return (
    <Autocomplete
      disablePortal
      size="small"
      options={options}
      loading={loading}
      filterOptions={(x) => x}
      getOptionLabel={(o) => o?.courseName || ""}
      value={selectedCourse}
      inputValue={inputValue}
      onInputChange={(_, newInputValue, reason) => {
        if (reason === "reset") return;
        setInputValue(newInputValue);
      }}
      onChange={(_, v) => {
        onSelect(v);
        if (v?.courseName) setInputValue(v.courseName);
      }}
      isOptionEqualToValue={(o, v) => o?.courseId === v?.courseId}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={16} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      ListboxProps={{ style: { maxHeight: "220px" }, ...listboxProps }}
      noOptionsText={
        loading ? "Searching…" : debouncedSearch ? "No matching courses" : "Type to search courses"
      }
    />
  );
};

export default CourseAutocomplete;
